import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import apis from '../../../app/apis';
import cts from '../../../app/cts';
import { BackButton } from '../../../components';
import oneOf from '../DepoEvents_Components/helpers';


/**
 * Components
 */
import {
  Loading, Header, ListItem
} from './components';


const endpoints = ({ localityId, matId, location }) => ({
  'event-list': apis.getEventsApi(localityId, matId),
  'depo-list': apis.getDeposApi(localityId, matId, location),
});


/**
 * useEvents hook
 * This hooks is used to get list of events
 * @param {number} matId
 */
const useDepoEvents = (localityId, matId, location, kind) => {
  const [list, setList] = useState({});
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getDepoEvents = async () => {
      try {
        setLoading(true);
        const { data, status } = await cts('get', endpoints({ localityId, matId, location })[kind]);
        if (!data && status !== 200) {
          throw new Error('Error getting event list');
        }
        setList(data.content.response);
      } catch (e) {
        setError(true);
      } finally {
        setLoading(false);
      }
    };
    getDepoEvents();
  }, [localityId, matId, location, kind]);

  return {
    list,
    error,
    loading
  };
};


const Container = styled.div`
  height: auto;
  overflow: auto;
`;


const routes = {
  'event-list': '/event-details',
  'depo-list': '/depo-details',
};


const DepoEventList = ({
  localityId, location, history
}) => {
  const matId = location.state.id; // material id
  const kind = location.state.type; // depo-list - event-list

  /**
   * Get list hook
   */
  const {
    list, loading, error
  } = useDepoEvents(localityId, matId, '', kind);


  /**
   * Normalize List
   */
  const normaList = 'results' in list && list.results.map((item, i) => {
    const id = oneOf(['drop_event_id', 'drop_depot_id'], item);
    const name = oneOf(['depot_nm', 'event_nm'], item);
    return ({
      key: `depo-event-${id}-${i}`,
      id,
      name,
      ...item
    });
  });


  /**
   * Navigate to event or depo details page
   *
   * @param {*} item Event/Depo item item
   */
  const itemClickHandler = (item, kind) => {
    const depoEventId = (kind === 'event-list') ? `${item.id}-${item.drop_event_loc_id}` : item.id;
    history.push(routes[kind], { id: depoEventId, kind });
  };


  return (
    <Container>
      <BackButton />
      {
        loading && <Loading />
      }
      {
        !error
        && normaList
        && normaList.length
          ? (
            <div>
              <Header kind={kind}>
                {list.context.mat_nm}
              </Header>
              <div style={{ padding: '0 6px' }}>
                {
                  normaList.map((li) => (
                    <ListItem
                      key={li.key}
                      title={li.name}
                      details={li.display_addr}
                      onClick={() => itemClickHandler(li, kind)}
                    />
                  ))
                }
              </div>
            </div>
          ) : null
      }
    </Container>
  );
};

export default withRouter(connect((state) => (
  { localityId: state.app.localityId }
))(DepoEventList));
